module.exports = __webpack_public_path__ + "static/img/p1.3c67a5fa.png";